import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import ExperienceFilterSubNavbar from 'modules/common/SubBars/ExperienceFilterSubNavbar';
import React from 'react';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';

const AsyncSearchResults = Load(
  () =>
    import(
      /* webpackChunkName: "search-page" */ './containers/SearchResultsContainer'
    ),
  {},
  true,
);
const AsyncSearchInput = Load(
  () =>
    import(
      /* webpackChunkName: "search-input-page" */ './containers/SearchInputPage'
    ),
  {},
  true,
);

export const searchResultsRoute: RouteDescriptor = {
  id: 'search.results',
  path: `${basePath}/s/*`,
  label: 'Search Results',
  audience: 'both',
  layout: 'navigational',
  module: 'search',
};

export const searchInputRoute: RouteDescriptor = {
  id: 'search.input',
  path: `${basePath}/search/`,
  label: 'Search Input',
  audience: 'both',
  layout: 'navigational',
  module: 'search',
};

export const searchRoutes = [
  createNavigationalRoute({
    key: searchResultsRoute.id,
    id: searchResultsRoute.id,
    subNavbar: <ExperienceFilterSubNavbar />,
    path: searchResultsRoute.path,
    component: AsyncSearchResults,
    handle: createRouteHandle(searchResultsRoute),
    showSearchInNavbar: true,
    showBottomNavigation: true,
  }),
  createNavigationalRoute({
    key: searchInputRoute.id,
    id: searchInputRoute.id,
    path: searchInputRoute.path,
    component: AsyncSearchInput,
    handle: createRouteHandle(searchInputRoute),
    noNavbar: true,
    hideFooter: true,
  }),
];

export const searchRouteDescriptors = [searchResultsRoute, searchInputRoute];

export default searchRoutes;
